// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__iu8yh","row":"Node_row__s0u-z","label":"Node_label__1kxfv","footer":"Node_footer__1n-h7"};